// extracted by mini-css-extract-plugin
export default {"alertModal":"alertModal_alertModal__WXOnr","text":"alertModal_text__Hvhds","source":"alertModal_source__W921j","pdf":"alertModal_pdf__V8f3D","button":"alertModal_button__4JBAS"};